// Libs
import React from 'react'
import PropTypes from 'prop-types'
import {
  maybeFunction,
} from './propTypes'

// Styles
import {
  headerCellStyle,
} from './styles'

// Components
import AscIcon from './AscIcon'
import DescIcon from './DescIcon'

const descIcon = <DescIcon />

// Exports
export const ColumnHeader = ({
  children,
  attr,
  width,
  type,
  onSort,
  sortedBy,
  asc,
  hideSorters,
}) => (
  <div
    data-test='ColumnHeader'
    style={{
      ...headerCellStyle,
      flex: `0 0 ${width}%`,
      justifyContent: type === 'number' ? 'flex-end' : 'flex-start',
      cursor: onSort ? 'pointer' : 'default',
      overflow: 'hidden',
      ...hideSorters ? {
        cursor: 'auto',
      } : {},
    }}
    onClick={!hideSorters ? onSort: undefined}
  >
    <div>{children}</div>
    {onSort && !hideSorters ? (
      !sortedBy || asc ? <AscIcon enabled={sortedBy} /> : descIcon
    ) : null}
  </div>
)

ColumnHeader.propTypes = {
  width: PropTypes.number,
  attr: PropTypes.string,
  onSort: maybeFunction,
  children: PropTypes.node,
  type: PropTypes.oneOf(['number', 'boolean']),
  sortedBy: PropTypes.bool.isRequired,
  hideSorters: PropTypes.bool,
  asc: PropTypes.bool,
}

export default ColumnHeader
